export const getGroupeTypeFile = type => {
	if (!type) return "unknown";

	const imageTypes = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "tiff", "svg", "ico", "heic"];
	const videoTypes = ["mp4", "webm", "ogg", "mov", "avi", "wmv", "flv", "mkv", "m4v"];
	const audioTypes = ["mp3", "wav", "ogg", "aac", "flac", "m4a", "wma", "alac"];
	const documentTypes = [
		"pdf",
		"doc",
		"docx",
		"txt",
		"rtf",
		"odt",
		"xls",
		"xlsx",
		"ppt",
		"pptx",
		"csv",
		"md",
		"epub"
	];
	const archiveTypes = ["zip", "rar", "7z", "tar", "gz", "bz2", "xz"];
	const codeTypes = [
		"html",
		"css",
		"js",
		"ts",
		"jsx",
		"tsx",
		"json",
		"xml",
		"yml",
		"yaml",
		"py",
		"java",
		"cpp",
		"c",
		"cs",
		"php",
		"rb",
		"go",
		"sh"
	];

	const normalizedType = type.toLowerCase();

	if (imageTypes.includes(normalizedType)) return "image";
	if (videoTypes.includes(normalizedType)) return "video";
	if (audioTypes.includes(normalizedType)) return "audio";
	if (documentTypes.includes(normalizedType)) return "file";
	if (archiveTypes.includes(normalizedType)) return "file";
	if (codeTypes.includes(normalizedType)) return "file";

	return "unknown";
};
